import {styled} from '@mui/material';

const Span = styled('span')({});

export default Span;
